import { registerQuery } from 'data-fetching-client';
import { fetchAvailabilityPage, fetchV2PublicAvailabilityInfo } from 'MeetingsLib/api/bookingAPIV2';
export const fetchV2PublicAvailabilityInfoQuery = registerQuery({
  fieldName: 'publicAvailabilityInfo',
  args: ['slug', 'now'],
  fetcher: queryParams => fetchV2PublicAvailabilityInfo(queryParams)
});
export const fetchAvailabilityPageQuery = registerQuery({
  fieldName: 'publicAvailabilityPage',
  args: ['monthOffset', 'slug'],
  fetcher: queryParams => fetchAvailabilityPage(queryParams)
});